import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { SkyResourcesModule } from '../../resources';

import { SkyTileDashboardColumnComponent } from './tile-dashboard-column.component';


export class SkyTileDashboardColumnModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTileDashboardColumnComponent
  ],
  imports: [
    CommonModule,
    DragulaModule,
    SkyResourcesModule
  ],
  exports: [
    SkyTileDashboardColumnComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
